import { useNotify, useTranslate, useUpdate } from "ra-core";

import { opportunityStageLabelKey } from "./labels";
import { stagePatch } from "./opportunities";
import type { MarketOpportunity, OpportunityStage } from "./types";

/** Optimistic stage move (menu or kanban drop) with a Spanish toast. */
export const useStageChange = () => {
  const [update] = useUpdate<MarketOpportunity>();
  const notify = useNotify();
  const translate = useTranslate();
  return (opportunity: MarketOpportunity, stage: OpportunityStage) => {
    const patch = stagePatch(opportunity, stage);
    if (!patch) return;
    update("market_opportunities", patch, {
      mutationMode: "optimistic",
      onSuccess: () =>
        notify("market.opportunities.moved", {
          type: "success",
          messageArgs: { stage: translate(opportunityStageLabelKey(stage)) },
        }),
      onError: () => notify("market.opportunities.error", { type: "error" }),
    });
  };
};
